'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsPower = function MdSettingsPower(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 40v-3.4h3.4v3.4h-3.4z m2.6-32.6c3.4 2.4 5.8 6.4 5.8 11 0 7.3-6.1 13.2-13.4 13.2s-13.4-5.9-13.4-13.2c0-4.6 2.4-8.6 5.8-11l2.4 2.4c-2.9 1.8-4.8 5-4.8 8.6 0 5.5 4.5 10 10 10s10-4.5 10-10c0-3.6-2-6.8-4.8-8.6z m-6-4v16.6h-3.2v-16.6h3.2z m-3.2 36.6v-3.4h3.2v3.4h-3.2z m-6.8 0v-3.4h3.4v3.4h-3.4z' })
        )
    );
};

exports.default = MdSettingsPower;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-power.js
// module id = 3523
// module chunks = 0